import { createSelector } from 'reselect';

const selectFlightData = (state) => state.flightData;

export const selectFlightIds = createSelector(
  [selectFlightData],
  (flightData) => flightData.flightIds
);

export const selectFlightTimes = createSelector(
  [selectFlightData],
  (flightData) => flightData.flightTimes
);

export const selectIsFlightIdsLoading = createSelector(
  [selectFlightData],
  (flightData) => flightData.flightIdsLoading
);

export const selectSelectedFlightIds = createSelector(
  [selectFlightData],
  (flightData) => flightData.selectedFlightIds
);

export const selectDof = createSelector(
  [selectFlightData],
  (flightData) => flightData.dof
);

export const selectFlightCustomerData = createSelector(
  [selectFlightData],
  (flightData) => flightData.flightCustomerData
);

export const selectIsCustomerDataLoading = createSelector(
  [selectFlightData],
  (flightData) => flightData.customerDataLoading
);

export const selectCustomerCount = createSelector(
  [selectFlightData],
  (flightData) => flightData.customerCount
);

export const selectFilteredFlightIds = createSelector(
  [selectFlightData],
  (flightData) => flightData.filteredFlightIds
);

export const selectFilterTimeStart = createSelector(
  [selectFlightData],
  (flightData) => flightData.filter.time.start
);

export const selectFilterTimeEnd = createSelector(
  [selectFlightData],
  (flightData) => flightData.filter.time.end
);